import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-big-dots-spinner[loading]',
  templateUrl: './big-dots-spinner.component.html',
  styleUrls: ['./big-dots-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BigDotsSpinnerComponent {
  fullScreen: InputSignal<boolean> = input.required();
  loading: InputSignal<boolean> = input.required();
}
